<script setup lang="ts">
// markstream custom component for a Slack broadcast ping (<!channel>,
// <!here>, <!everyone>), emitted by slackMarkdown.ts as
// `<broadcast kind="here"></broadcast>`. Renders an inline `@kind` pill,
// slightly emphasized vs a normal mention because a broadcast notifies
// many people. The `@` text is the marker - no glyph icon.
import { computed } from 'vue';
import { attr } from './nodeAttrs';

const props = defineProps<{ node: any }>();

const kind = computed(() => attr(props.node, 'kind') || 'channel');
</script>

<template>
  <span class="broadcast-chip" :title="`@${kind}`">@{{ kind }}</span>
</template>

<style scoped>
.broadcast-chip {
  display: inline-flex;
  align-items: center;
  padding: 1px 7px;
  border-radius: var(--radius-pill);
  background: var(--accent-soft);
  color: var(--ink-display);
  font-size: 0.9em;
  font-weight: 700;
  line-height: 1.4;
  vertical-align: baseline;
  white-space: nowrap;
}
</style>
